import { useEffect } from 'react'

import { Box, FloraButton, Flex } from '@grupoboticario/flora-react'

import ActionModal from '@/components/Modal/ActionModal'
import { PREVIEW_SECTIONS, PREVIEW_LABELS } from '@/constants/eventPreviewLabels'
import { getEventTypeLabel, getImagePreviewUrl, getSelectedBrandsLabel } from '@/utils/eventFormatters'

import DatesSection from './DatesSection'
import DetailsSection from './DetailsSection'
import DisplaySection from './DisplaySection'
import {
  modalContainerStyle,
  modalContentStyle,
  mainBoxStyle,
  sectionsContainerStyle,
  buttonsContainerStyle
} from './styles'
import { useEventPreview } from './useEventPreview'

const EventPreviewModal = ({ open, onOpenChange, formValues, onConfirm, isLoading = false }) => {
  const { openSections, toggleSection } = useEventPreview()

  const eventTypeLabel = getEventTypeLabel(formValues.type)
  const imagePreview = getImagePreviewUrl(formValues)
  const imagePreviewUrl = imagePreview?.url || null
  const selectedDays = formValues.days || []
  const selectedBrands = getSelectedBrandsLabel(formValues.brands)

  useEffect(() => {
    return () => {
      if (imagePreview?.revoke) {
        imagePreview.revoke()
      }
    }
  }, [imagePreview])

  return (
    <ActionModal
      css={modalContainerStyle}
      onOpenChange={onOpenChange}
      open={open}
      size="lg"
      title={PREVIEW_LABELS.MODAL_TITLE}
    >
      <Box css={modalContentStyle}>
        <Box css={mainBoxStyle}>
          <Box css={sectionsContainerStyle}>
            <DetailsSection
              eventTypeLabel={eventTypeLabel}
              formValues={formValues}
              imagePreviewUrl={imagePreviewUrl}
              isOpen={openSections[PREVIEW_SECTIONS.DETAILS]}
              onToggle={() => toggleSection(PREVIEW_SECTIONS.DETAILS)}
            />

            <DatesSection
              isOpen={openSections[PREVIEW_SECTIONS.DATES]}
              onToggle={() => toggleSection(PREVIEW_SECTIONS.DATES)}
              pointsPerTicket={formValues.pointsPerTicket}
              selectedDays={selectedDays}
            />

            <DisplaySection
              formValues={formValues}
              isOpen={openSections[PREVIEW_SECTIONS.DISPLAY]}
              onToggle={() => toggleSection(PREVIEW_SECTIONS.DISPLAY)}
              selectedBrands={selectedBrands}
            />
          </Box>
        </Box>

        <Flex css={buttonsContainerStyle} gap="$2" justify="flex-end">
          <FloraButton disabled={isLoading} onClick={() => onOpenChange(false)} hierarchy="secondary">
            {PREVIEW_LABELS.BUTTON_BACK}
          </FloraButton>
          <FloraButton disabled={isLoading} isFull isLoading={isLoading} onClick={onConfirm}>
            {PREVIEW_LABELS.BUTTON_CONFIRM}
          </FloraButton>
        </Flex>
      </Box>
    </ActionModal>
  )
}

export default EventPreviewModal
